import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDynamicDatetimeInput]',
})
export class DynamicDatetimeInputDirective {
  private element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @HostListener('focus')
  handleFocus(): void {
    this.element.nativeElement.type = 'datetime-local';
  }

  @HostListener('blur')
  handleBlur(): void {
    if (this.element.nativeElement.value === '') {
      this.element.nativeElement.type = 'text';
    }
  }
}
